import { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Download, FileText, Upload, CheckCircle2, Loader2, XCircle } from "lucide-react";

function StatusIcon({ existing, obrigatorio }) {
  if (existing) return <CheckCircle2 className="w-5 h-5 text-green-600 shrink-0" />;
  if (obrigatorio) return <XCircle className="w-5 h-5 text-orange-500 shrink-0" />;
  return <FileText className="w-5 h-5 text-slate-300 shrink-0" />;
}

export function DocumentoRow({ tipo, inscricaoId, existing, uploading, onUpload }) {
  return (
    <div className="flex items-center gap-3 p-3 bg-white hover:bg-slate-50" data-testid={`doc-row-${tipo.key}-${inscricaoId}`}>
      <StatusIcon existing={existing} obrigatorio={tipo.obrigatorio} />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold flex items-center gap-2 flex-wrap">
          {tipo.label}
          {tipo.obrigatorio && <Badge className="h-4 px-1 bg-orange-100 text-orange-700 text-[9px]">Obrigatório</Badge>}
        </div>
        {existing ? (
          <div className="text-xs text-slate-500 truncate">{existing.filename}</div>
        ) : (
          <div className="text-xs text-slate-400 italic">{tipo.condicional || "Não enviado"}</div>
        )}
      </div>
      <div className="flex items-center gap-2">
        {existing && (
          <Button
            size="sm"
            variant="outline"
            onClick={() => window.open(`${API}/inscricoes/${inscricaoId}/documentos/${existing.id}/download`, "_blank")}
            data-testid={`btn-download-doc-${tipo.key}-${inscricaoId}`}
            title="Baixar"
          >
            <Download className="w-3.5 h-3.5" />
          </Button>
        )}
        <label className="relative">
          <input
            type="file"
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={(e) => onUpload(tipo.key, e.target.files?.[0])}
            disabled={uploading}
            className="absolute inset-0 opacity-0 cursor-pointer disabled:cursor-not-allowed"
            data-testid={`input-upload-${tipo.key}-${inscricaoId}`}
          />
          <Button size="sm" variant="outline" disabled={uploading} className="pointer-events-none">
            {uploading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}
            <span className="ml-1.5 text-xs">{existing ? "Substituir" : "Enviar"}</span>
          </Button>
        </label>
      </div>
    </div>
  );
}
